/**
 * CollabV3Badge 컴포넌트
 * @description 상세의 작은 알약 — 아티스트 · 운영 제공 · 상태 · 작품 칩. 앱 DS `Badge` 의 자리인데 웹
 *   DS 에는 누르는 `Chip` 만 있어(누르지 않는 표식이 없다) 2.0 상세의 상태 배지처럼 도메인 안에서
 *   토큰으로 그린다.
 * @example <CollabV3Badge text="In progress" tone="inverse" live />
 */
import { memo } from "react";

import { collabV3BadgeStyles, collabV3DetailStyles } from "./CollabV3Detail.styles";
import type { CollabV3BadgeProps } from "./CollabV3Detail.types";

const CollabV3Badge = memo<CollabV3BadgeProps>(({ text, tone, live }) => (
  <span className={collabV3BadgeStyles({ tone })}>
    {live ? <span aria-hidden className={collabV3DetailStyles.liveDot} /> : null}
    {text}
  </span>
));

CollabV3Badge.displayName = "CollabV3Badge";

export default CollabV3Badge;
